import { render, staticRenderFns } from "./AdminPayments.vue?vue&type=template&id=0255c353&"
import script from "./AdminPayments.vue?vue&type=script&lang=js&"
export * from "./AdminPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports